import Cookies from 'js-cookie';
export var readCookie = function readCookie(cookieKey) {
  return Cookies.get(cookieKey);
};
export var writeCookie = function writeCookie(cookieKey, cookieValue, config) {
  return Cookies.set(cookieKey, cookieValue, config);
};